window.addEventListener('load', () => {
  let playIco = "https://cdn.shopify.com/s/files/1/0611/7598/8421/files/play_circle_outline_24px.svg?v=1686544329"
  let vids = document.querySelectorAll('.enrm-bg-video')
  let waterMark = document.querySelector('#enap-video-9878')

  vids.forEach(v => {
    v.innerHTML = ''
    let img = document.createElement('img')
    img.setAttribute('src', playIco)
    img.style.cssText = `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 80px;
      max-height: 80px;
      z-index: 100;
    `
    v.appendChild(img)
  })

  console.log(waterMark.firstElementChild)

  waterMark.removeChild(waterMark.getElementsByClassName('enrm-branding')[0])
  // waterMark.firstElementChild.style.display = 'none!important'
})